import { Component, OnInit } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {CcediService} from "../services/ccedi.service";
import * as moment from "moment/moment";
import {AuthStats} from "../../dto/Ccedi/ccedi-models";

@Component({
  selector: 'app-ccedi',
  templateUrl: './ccedi.component.html',
  styleUrls: ['./ccedi.component.css']
})
export class CcediComponent implements OnInit {
  isLoading = false;
  from: Date;
  to: Date;
  data: AuthStats|null = null;

  colorScheme = {
    domain: [ '#f6a14a', '#8bc34a', ]
  };
  view: any[] = [2000, 500];

  multi = [

  ];

  // load timeline graph
  // options
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = true;
  legendTitle = 'Legend';
  legendPosition = 'right';
  showXAxisLabel = true;
  xAxisLabel = 'Date';
  showYAxisLabel = true;
  yAxisLabel = 'Count';
  showGridLines = true;
  innerPadding = '10%';
  animations: boolean = true;
  barPadding: number = 1;

  barCustomColors =  [];
  currentXAxisTicks: any[] | null = null;

  onSelectGraph($event: any) {

  }


  constructor(
    private ccediService: CcediService,
  ) {

    this.from = moment(moment().subtract(14, 'days')).toDate();
    this.to = moment().toDate();

  }

  ngOnInit(): void {
    this.loadData();
  }

  private generateLoadTimelineGraphData() {

    let newMulti = [];
    let i = 0;
    let newXAxisTicks = [];
    let xAxisTicksFactor = this.data.parts[0].values.length < 20 ? 1 : (this.data.parts[0].values.length < 100 ? 0.5 : 0.2)

    const successData = {
      name: "Success",
      series: [],
    }
    while ( i < this.data.parts[0].values.length) {

      let success = this.data.parts[0].values[i];
      let time = moment(success.time).format('YYYY-MM-DD HH:mm');
      if ( i % (1/xAxisTicksFactor) == 0 ) {
        newXAxisTicks.push(time);
      }
      successData.series.push({
        name: time,
        value: success.value,
      });

      i++;
    }

    i = 0;
    const declineData = {
      name: "Declines",
      series: [],
    }
    while ( i < this.data.parts[1].values.length) {
      let decline = this.data.parts[1].values[i];
      let time = moment(decline.time).format('YYYY-MM-DD HH:mm');
      declineData.series.push({
        name: time,
        value: decline.value,
      });

      i++;
    }
    newMulti.push(declineData);
    newMulti.push(successData);


    this.multi = [...newMulti];
    if ( xAxisTicksFactor === 1 )
      this.currentXAxisTicks = null;
    else
      this.currentXAxisTicks = newXAxisTicks;

  }

  loadData() {
    this.isLoading = true;
    this.ccediService.getAuthStats(this.from, this.to, "1h", null, null).subscribe(data => {
      this.data = data;
      this.generateLoadTimelineGraphData();
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
    });
  }
}
